import { reducerWithInitialState } from 'typescript-fsa-reducers'
import { Theme } from '@mui/material'

import {
  requestFailed,
  requestFinished,
  requestStarted, setGeneralOptions,
  setMessage,
  setLicensePermissions,
  setTheme, setUser,
} from './common.actions'
import { ActionCall, GeneralOptions, SocialNetworkLicensePermissions } from '@professocial/professocialTypes/types/commonTypes'
import getAppTheme from '../../defaults/getAppTheme'
import { produce } from 'immer'

import { Message } from '@professocial/professocialTypes/types/messageTypes'

export interface CommonState {
  theme: Theme
  user?: any
  message?: Message
  licensePermissions: SocialNetworkLicensePermissions
  generalOptions?: GeneralOptions
  requests: ActionCall[]
}

const INITIAL_STATE: CommonState = {
  theme: getAppTheme(),
  licensePermissions: {
    facebook: true,
  },
  requests: [],
}

const triggerProfessocialMessage = (data: Message) => {
  window.dispatchEvent(new CustomEvent('ProfessocialMessage', { detail: data }))
}

export const CommonReducer = reducerWithInitialState(INITIAL_STATE)
  .case(setTheme, (state, theme) => {
    return ({ ...state, theme })
  })
  .case(setUser, (state, user) => {
    return ({ ...state, user })
  })
  .case(setLicensePermissions, (state, socialMediaNetworks) => {
    return ({ ...state, socialMediaNetworks })
  })
  .case(setGeneralOptions, (state, generalOptions) => {
    return ({ ...state, generalOptions })
  })
  /**
   * Message Management
   */
  .case(setMessage, (state, message) => {
    // Fix - wait while the reducer is executing
    setTimeout(() => triggerProfessocialMessage(message))

    return produce(state, (draft) => {
      draft.message = message
    })
  })

  /**
   *  Requests Management
   */
  .case(requestStarted, (state, action) => {
    return produce(state, (draft) => {
      const existingRequest = draft.requests.findIndex(request => request.type === action.type)
      if (existingRequest !== -1) {
        draft.requests[existingRequest].inProgress = true
        draft.requests[existingRequest].status = 'pending'
        draft.requests[existingRequest].error = null
      } else {
        draft.requests.push({ type: action.type, status: 'pending', inProgress: true, error: null })
      }
    })
  })
  .case(requestFinished, (state, action) => {
    return produce(state, (draft) => {
      const index = draft.requests.findIndex(request => request.type === action.type)
      if (index !== -1) {
        draft.requests[index].inProgress = false
        draft.requests[index].status = 'success'
        draft.requests[index].error = null
      }
      setTimeout(() => action.message && triggerProfessocialMessage({
        severity: action.message.severity,
        message: action.message.message,
        eventType: action.message.eventType,
      }))
    })
  })
  .case(requestFailed, (state, action) => {
    return produce(state, (draft) => {
      const index = draft.requests.findIndex(request => request.type === action.type)
      if (index !== -1) {
        draft.requests[index].inProgress = false
        draft.requests[index].status = 'failed'
        draft.requests[index].error = action.error
      }
      setTimeout(() => action.message && triggerProfessocialMessage({
        severity: action.message.severity,
        message: action.message.message,
        eventType: action.message.eventType,
      }))
    })
  })
